import { UserText } from '@Constants/UserText';

// @ai-generated 2026-10-09T14:35:50+00:00 by niklas.eicker@tngtech.com using Claude Opus 5.5 (1M context)
/** Sets the browser tab title to the mandant's display name, or back to the app name. */
export function applyDocumentTitle(displayName: string | undefined) {
    document.title = displayName || UserText.APP_NAME;
}

// @ai-generated 2026-10-09T14:35:50+00:00 by niklas.eicker@tngtech.com using Claude Opus 5.5 (1M context)
/** Points every favicon link at the mandant's favicon, or back at the ones from index.html. */
export function applyFavicon(faviconUrl: string | undefined) {
    document.querySelectorAll<HTMLLinkElement>('link[rel~="icon"]').forEach((link) => {
        link.dataset.defaultHref ??= link.getAttribute('href') ?? '';
        link.dataset.defaultType ??= link.getAttribute('type') ?? '';

        if (faviconUrl) {
            link.setAttribute('href', faviconUrl);
            link.removeAttribute('type');
            return;
        }
        link.setAttribute('href', link.dataset.defaultHref);
        if (link.dataset.defaultType) {
            link.setAttribute('type', link.dataset.defaultType);
        }
    });
}
